import { ClassifiedAd, AdCategory } from '../models/classified-ad.model';

export const MOCK_CLASSIFIED_ADS: ClassifiedAd[] = [
  {
    id: 1,
    titleKey: 'classified-ads.vintage-dining-table-title',
    title: 'classified-ads.vintage-dining-table-title',
    descriptionKey: 'classified-ads.vintage-dining-table-description',
    description: 'classified-ads.vintage-dining-table-description',
    category: AdCategory.FURNITURE,
    price: 450.0,
    currency: 'USD',
    authorKey: 'classified-ads.john-smith',
    author: 'classified-ads.john-smith',
    authorId: 1,
    createdDate: new Date('2024-01-15T10:30:00Z'),
    updatedDate: new Date('2024-01-15T10:30:00Z'),
    isActive: true,
    images: [
      'https://example.com/images/dining-table-1.jpg',
      'https://example.com/images/dining-table-2.jpg',
    ],
    contactInfo: 'Call or text: +1-555-0101',
    locationKey: 'classified-ads.dubai-location',
    location: 'classified-ads.dubai-location',
  },
  {
    id: 2,
    titleKey: 'classified-ads.macbook-pro-title',
    title: 'classified-ads.macbook-pro-title',
    descriptionKey: 'classified-ads.macbook-pro-description',
    description: 'classified-ads.macbook-pro-description',
    category: AdCategory.ELECTRONICS,
    price: 1200.0,
    currency: 'USD',
    authorKey: 'classified-ads.maria-garcia',
    author: 'classified-ads.maria-garcia',
    authorId: 2,
    createdDate: new Date('2024-01-14T14:20:00Z'),
    updatedDate: new Date('2024-01-14T14:20:00Z'),
    isActive: true,
    images: [
      'https://example.com/images/macbook-1.jpg',
      'https://example.com/images/macbook-2.jpg',
    ],
    contactInfo: 'Email: maria.garcia@email.com',
    locationKey: 'classified-ads.dubai-location',
    location: 'classified-ads.dubai-location',
  },
  {
    id: 3,
    titleKey: 'classified-ads.honda-civic-title',
    title: 'classified-ads.honda-civic-title',
    descriptionKey: 'classified-ads.honda-civic-description',
    description: 'classified-ads.honda-civic-description',
    category: AdCategory.VEHICLES,
    price: 18500.0,
    currency: 'USD',
    authorKey: 'classified-ads.david-johnson',
    author: 'classified-ads.david-johnson',
    authorId: 3,
    createdDate: new Date('2024-01-12T09:45:00Z'),
    updatedDate: new Date('2024-01-12T09:45:00Z'),
    isActive: true,
    images: [
      'https://example.com/images/honda-civic-1.jpg',
      'https://example.com/images/honda-civic-2.jpg',
    ],
    contactInfo: 'Call: +1-555-0301',
    locationKey: 'classified-ads.dubai-location',
    location: 'classified-ads.dubai-location',
  },
  {
    id: 4,
    titleKey: 'classified-ads.tutoring-services-title',
    title: 'classified-ads.tutoring-services-title',
    descriptionKey: 'classified-ads.tutoring-services-description',
    description: 'classified-ads.tutoring-services-description',
    category: AdCategory.SERVICES,
    price: 50.0,
    currency: 'USD',
    authorKey: 'classified-ads.lisa-brown',
    author: 'classified-ads.lisa-brown',
    authorId: 4,
    createdDate: new Date('2024-01-10T16:15:00Z'),
    updatedDate: new Date('2024-01-10T16:15:00Z'),
    isActive: true,
    images: [],
    contactInfo: 'Email: lisa.brown@email.com or call +1-555-0401',
    locationKey: 'classified-ads.dubai-location',
    location: 'classified-ads.dubai-location',
  },
  {
    id: 5,
    titleKey: 'classified-ads.guitar-lessons-title',
    title: 'classified-ads.guitar-lessons-title',
    descriptionKey: 'classified-ads.guitar-lessons-description',
    description: 'classified-ads.guitar-lessons-description',
    category: AdCategory.SERVICES,
    price: 40.0,
    currency: 'USD',
    authorKey: 'classified-ads.robert-wilson',
    author: 'classified-ads.robert-wilson',
    authorId: 5,
    createdDate: new Date('2024-01-08T11:30:00Z'),
    updatedDate: new Date('2024-01-08T11:30:00Z'),
    isActive: true,
    images: ['https://example.com/images/guitar-lessons.jpg'],
    contactInfo: 'Text: +1-555-0501',
    locationKey: 'classified-ads.dubai-location',
    location: 'classified-ads.dubai-location',
  },
];
